// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
import FlexItem, { FlexItemProps } from "@insite/content-library/Widgets/Brand/FlexItem";
import FlexWrapContainer, { FlexWrapContainerProps } from "@insite/content-library/Widgets/Brand/FlexWrapContainer";

// import Badge from "@insite/mobius/Badge"; - bunzl custom code
import { LazyImageProps } from "@insite/mobius/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { DetailedHTMLProps, ImgHTMLAttributes, useState } from "react";
import { css } from "styled-components";

/* Starter Custom Code */
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
/* Starter Custom Code */

// Store Custom Code
import Badge from "@store/MobiusOverrides/Badge/Badge";

interface Props {
    badgeList: BadgeModel[];
    maxBadges: number;
    extendedStyles?: ProductImageBadgesStyles;
    numberOfColumns?: number;
    // Starter Custom Code
    useImageSizesStyles?: boolean;
    badgeSizes?: BadgeSizes;
}

// Store Custom Code - >
export interface BadgeSizes {
    Small: InjectableCss<{}>;
    Medium: InjectableCss<{}>;
    Large: InjectableCss<{}>;
}
// bunzl custom code <---
export interface ProductImageBadgesStyles {
    container?: InjectableCss;
    imageContainer?: FlexWrapContainerProps;
    imageItem?: FlexItemProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    image?: LazyImageProps;
    // Starter Custom Code
    flexWrapper?: FlexWrapperPresentationProps;
    // Store Custom Code
    imageBadgeWrapperStyles?: InjectableCss;
}

export const productImageBadgesStyles: ProductImageBadgesStyles = {
    flexWrapper: {
        gap: pxToRem(7),
        // Store Custom Code - >
        extendedStyles: {
            content: {
                css: css`
                    align-items: center;
                    display: flex;
                `,
            },
            item: {
                css: css`
                    flex-basis: unset;
                `,
            },
            wrapper: {
                css: css`
                    margin-bottom: 0.25rem;
                `,
            },
            // bunzl custom code <---
        },
    },
};

const ProductImageBadges = ({
    badgeList,
    maxBadges,
    extendedStyles,
    numberOfColumns,
    // Starter Custom Code
    useImageSizesStyles = false,
    badgeSizes,
}: //
Props) => {
    const [styles] = useState(() => mergeToNew(productImageBadgesStyles, extendedStyles));

    /* Starter Custom Code */
    const smallImgProps = {
        style: {
            width: "50%",
            height: "auto",
        },
    };

    const mediumImgProps = {
        style: {
            width: "75%",
            height: "auto",
        },
    };

    const largeImgProps = {
        style: {
            width: "100%",
            height: "auto",
        },
    };

    // Store Custom Code - >

    // scaling badges by height instead of width for better alignment with text badges
    const badgeSizesImgProps = {
        style: {
            height: "100%",
            width: "auto",
        },
    };
    const getImageBadgeProps = (
        badge: BadgeModel,
    ): DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> | undefined => {
        // always default to extendedStyles if available
        if (extendedStyles?.badgeImageProps) {
            return styles.badgeImageProps;
        }
        if (!useImageSizesStyles && !badgeSizes) {
            return styles.badgeImageProps;
        }
        if (badgeSizes && !useImageSizesStyles) {
            return badgeSizesImgProps;
        }
        if (badge.detailWidgetBadgeSize === "Large") {
            return largeImgProps;
        }
        if (badge.detailWidgetBadgeSize === "Small") {
            return smallImgProps;
        }
        return mediumImgProps;
    };

    // bunzl custom code <--

    return (
        <FlexWrapper
            {...styles.flexWrapper}
            itemsPerRow={[numberOfColumns ?? 4]}
            data-test-selector="productImageBadges"
        >
            {badgeList.slice(0, maxBadges).map(badge => {
                const badgeSizeStyles =
                    badgeSizes && badgeSizes?.[(badge.detailWidgetBadgeSize as keyof BadgeSizes) || undefined];
                return (
                    <Badge
                        imageBadgeWrapperStyles={badgeSizeStyles || styles.imageBadgeWrapperStyles} // Store Custom Code
                        key={badge.id}
                        type={badge.badgeType}
                        value={badge.largeImageBadgePath}
                        imageAltText={badge.imageAltText || badge.name}
                        imageBadgeProps={
                            getImageBadgeProps(badge) // Store Custom Code
                        }
                    />
                );
            })}
        </FlexWrapper>
        /* Starter Custom Code */
    );
};

export default ProductImageBadges;
